const DocumentNormalBoldIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.8067 5.4143V11.6876C13.8067 13.3276 12.4667 14.6676 10.8267 14.6676H5.17336C3.53336 14.6676 2.19336 13.3276 2.19336 11.6876V5.4143C2.19336 4.2743 2.83336 3.28096 3.77336 2.78096C4.10003 2.60763 4.50669 2.84096 4.50669 3.2143C4.50669 4.2743 5.37336 5.14096 6.43336 5.14096H9.56669C10.6267 5.14096 11.4934 4.2743 11.4934 3.2143C11.4934 2.84096 11.8934 2.60763 12.2267 2.78096C13.1667 3.28096 13.8067 4.2743 13.8067 5.4143Z"
      fill="currentColor"
    />
    <path
      d="M9.56618 1.33398H6.43285C5.73952 1.33398 5.17285 1.89398 5.17285 2.58732V3.21398C5.17285 3.90732 5.73285 4.46732 6.42618 4.46732H9.56618C10.2595 4.46732 10.8195 3.90732 10.8195 3.21398V2.58732C10.8262 1.89398 10.2595 1.33398 9.56618 1.33398Z"
      fill="currentColor"
    />
  </svg>
);

export default DocumentNormalBoldIcon;
